import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'triggered-privacy-policy-view',
  templateUrl: './privacy-policy.view.html',
  styleUrls: ['./privacy-policy.view.scss']
})
export class PrivacyPolicyView implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
